import { Component, Inject } from '@angular/core';
import { HotelPhone } from '../../core/api/api.models';
import { BtrBookingService } from '../../core/services/btr-booking.service';
import { Subject, takeUntil } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { SearchAvailabilityQuery } from '../../core/models/booking-model';
import { IAppConfig, SupportTheme } from '../../core/config/app-config.model';
import { APP_CONFIG } from '../../core/config/app-config.service';

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass']
})
export class FooterComponent {
  constructor(
    private BtrBookingService: BtrBookingService,
    private route: ActivatedRoute,
    @Inject(APP_CONFIG) protected config: IAppConfig,
  ){

  }
  hotelPhones: HotelPhone[] = [];
  destroyed = new Subject();
  searchAvailabilityQuery: SearchAvailabilityQuery | undefined | null;
  theme?: SupportTheme;

  ngOnInit(): void {
    this.theme = this.config.themeDefault;
    this.BtrBookingService.readCountryHotelGroupList().pipe(takeUntil(this.destroyed)).subscribe({
      next: (res) => {
        if (res && res.success) {
          this.hotelPhones = res.hotelPhones;
        }
      }
    });
    this.route.queryParams.pipe(takeUntil(this.destroyed)).subscribe((params: any) => {
      this.loadSearchAvailabilityQuery(params);
    });
  }

  loadSearchAvailabilityQuery(params: any) {
    this.searchAvailabilityQuery = this.BtrBookingService.parseSearchAvailabitity(params);
  }

  getPhoneNumber(){
    if(this.hotelPhones.length && this.searchAvailabilityQuery && this.searchAvailabilityQuery.property){
      return this.hotelPhones.find(item => item.propertyCode == this.searchAvailabilityQuery?.property)?.phoneNumber;
    }

    return '';
  }

  gitLinkPhoneNumber(){
    if(this.hotelPhones.length && this.searchAvailabilityQuery && this.searchAvailabilityQuery.property){
      return `tel:${this.hotelPhones.find(item => item.propertyCode == this.searchAvailabilityQuery?.property)?.phoneNumber}`;
    }

    return '';
  }

  getLinkPrivacyPolicy() {
    if (this.config.LogoHeaderLink) {
      return `${this.config.LogoHeaderLink}/privacy-policy`;
    }

    return '';
  }
}
